import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ResizeSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ResizeSVG;
